import { render, staticRenderFns } from "./PackRecord.vue?vue&type=template&id=2df4556a&"
import script from "./PackRecord.vue?vue&type=script&lang=js&"
export * from "./PackRecord.vue?vue&type=script&lang=js&"
import style0 from "./PackRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports